// @core/api/endpoints/billing/get_invoice_numbering_scheme.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  InvoiceNumberingSchemeResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Get invoice numbering scheme
 * Returns an invoice numbering scheme by ID.
 */
export async function GetInvoiceNumberingScheme(
  scheme_id: string,
  options?: RequestOptions
): Promise<InvoiceNumberingSchemeResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/invoice-numbering-schemes/:scheme_id`;
  requestPath = requestPath.replace(':scheme_id', encodeURIComponent(scheme_id));
  const requestOptions = options;
  return client.get<InvoiceNumberingSchemeResponse>(requestPath, { ...requestOptions });
}
